"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NoDraftsFound = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _buttons = require("../../common/buttons");

var _noVideosFound = _interopRequireDefault(require("../../common/no-videos-found/no-videos-found"));

const NoDraftsFound = ({
  onCreateNewClick
}) => /*#__PURE__*/_react.default.createElement(_noVideosFound.default, {
  className: "no-drafts-found",
  title: "You have no saved videos yet"
}, /*#__PURE__*/_react.default.createElement(_buttons.PrimaryButton, {
  className: "no-drafts-found__create-new-btn",
  onClick: onCreateNewClick
}, "Create new"));

exports.NoDraftsFound = NoDraftsFound;
NoDraftsFound.propTypes = {
  onCreateNewClick: _propTypes.default.func.isRequired
};
var _default = NoDraftsFound;
exports.default = _default;